import React, { useState } from 'react';
import api from '../../../api';

const UserDetailModal = ({ user, onClose }) => {
  const [isBlocked, setIsBlocked] = useState(user.is_blocked == 0);
  const [isTrainingEnabled, setIsTrainingEnabled] = useState(user.override_disable_training_setting !== 'NO');

  const handleStatusToggle = async () => {
    const newStatus = !isBlocked;

    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/users/${user.id}/update-status`, {
        is_blocked: newStatus ? 0 : 1,
      });

      if (response.status === 200) {
        setIsBlocked(newStatus); // Only update state if API is successful
      } else {
        alert("Failed to update user status.");
      }
    } catch (error) {
      alert("Error updating user status.");
    }
  };

  const handleTrainingStatusToggle = async () => {
    const newTrainingStatus = !isTrainingEnabled;
    setIsTrainingEnabled(newTrainingStatus);
    try {
      const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/users/${user.id}/update-training-status`, {
        override_disable_training_setting: newTrainingStatus ? 'YES' : 'NO',
      }); 
      if (response.status === 200) {
      } else {
        setIsTrainingEnabled(!newTrainingStatus);
      }
    } catch (error) {
        setIsTrainingEnabled(!newTrainingStatus);
    }
  };

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
      <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-create">
        <div className="modal-content">
          <div className="modal-header justify-content-center">
            <div className="w-100">
              <h1 className="modal-title" id="modalManageClientsLabel">Personal Info & Goal</h1>
            </div>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          </div>
          <div className="modal-body px-md-4 pb-md-4">
            <div className="row justify-content-center gy-2">
              <div className="col-auto">
                <div className="clients-view-switch-wrap">
                  <span>Status</span>
                  <label className="switch">
                    <input type="checkbox" checked={isBlocked} onChange={handleStatusToggle} />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
              <div className="col-auto">
                <div className="clients-view-switch-wrap">
                  <span>Training Status</span>
                  <label className="switch">
                    <input type="checkbox" checked={isTrainingEnabled} onChange={handleTrainingStatusToggle} />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
              <div className="col-12"></div>
              <div className="col-auto clients-view-status-info">
                <span>Last Sign-in</span>: <span>{user.last_signin}</span>
              </div>
              <div className="col-auto clients-view-status-info">
                <span>Creation Date</span>: <span>{user.creation_date}</span>
              </div>
            </div>
          </div>
          <div className="modal-body px-md-4 pb-md-4">
            <div className="row gx-lg-5 mx-0">
              <div className="col-sm-6">
                <div className="per-info-goal-text">
                  <span>First Name:</span>
                  <span>{user.first_name}</span>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="per-info-goal-text">
                  <span>Last Name:</span>
                  <span>{user.last_name}</span>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="per-info-goal-text">
                  <span>Gender:</span>
                  <span>{user.gender}</span>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="per-info-goal-text">
                  <span>Date of Birth:</span>
                  <span>{user.date_of_birth || 'N/A'}</span>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="per-info-goal-text">
                  <span>Weight (kg):</span>
                  <span>{user.weight || '0'}</span>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="per-info-goal-text">
                  <span>Weight Goal (kg):</span>
                  <span>{user.weight_goal || '0'}</span>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="per-info-goal-text">
                  <span>Height (cm):</span>
                  <span>{user.height || '0'}</span>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="per-info-goal-text">
                  <span>Activity Level:</span>
                  <span>{user.activity_level || 'N/A'}</span>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="per-info-goal-text">
                  <span>Nutrition Goal:</span>
                  <span>{user.nutrition_goal || 'N/A'}</span>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="per-info-goal-text">
                  <span>Nutrition Goal Pace:</span>
                  <span>{user.nutrition_goal_pace || 'N/A'}</span>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="per-info-goal-text">
                  <span>Manual Macros:</span>
                  <span>{user.manual_macros ? 'Yes' : 'No'}</span>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="per-info-goal-text">
                  <span>Manual Protein Goal:</span>
                  <span>{user.manual_protein_goal || '0'}</span>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="per-info-goal-text">
                  <span>Manual Carb Goal:</span>
                  <span>{user.manual_carb_goal || '0'}</span>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="per-info-goal-text">
                  <span>Manual Fat Goal:</span>
                  <span>{user.manual_fat_goal || '0'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetailModal;
